import { render, staticRenderFns } from "./KidOrderDetail.vue?vue&type=template&id=4f1c0404&scoped=true"
import script from "./KidOrderDetail.vue?vue&type=script&lang=js"
export * from "./KidOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./KidOrderDetail.vue?vue&type=style&index=0&id=4f1c0404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c0404",
  null
  
)

export default component.exports